// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xSa2G","selected":"styles_selected__S8YFJ"};